import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Modal } from "antd";
import { CheckCircleTwoTone } from "@ant-design/icons";
import { getSecretDetails } from "../../selectors";
import { clearSecretDetails } from "../../actions";
import OidcDetails from "./OidcDetails";

class RegeneratedSecret extends React.Component {
  static propTypes = {
    client: PropTypes.string,
    secret: PropTypes.object,
    actions: PropTypes.shape({
      clearSecretDetails: PropTypes.func,
    }),
  };

  handleModalClose = () => {
    this.props.actions.clearSecretDetails();
  };

  render() {
    const { secret, client } = this.props;

    if (!secret || Object.keys(secret).length === 0) {
      return null;
    }

    return (
      <Modal
        open={true}
        onCancel={this.handleModalClose}
        onOk={this.handleModalClose}
        title="New Client Secret"
        centered
        closable
        okText="Close"
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <div style={{ marginBottom: "1rem" }}>
          <h3>
            Your secret has been regenerated{" "}
            <CheckCircleTwoTone twoToneColor="#52c41a" />
          </h3>
          <p>
            Make sure that you store the following clientID and secret safely.
          </p>
        </div>
        <OidcDetails clientId={client} secret={secret.value} />
      </Modal>
    );
  }
}

export default connect(
  (state) => ({
    secret: getSecretDetails(state),
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        clearSecretDetails,
      },
      dispatch,
    ),
  }),
)(RegeneratedSecret);
